import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';


export default class extends Controller {
  removeBackdrop() {
    const backdrops = document.querySelectorAll('.modal-backdrop');

    backdrops.forEach((backdrop) => backdrop.remove());
  }

  closeModal(event) {
    const modal = bootstrap.Modal.getInstance(this.element);
    modal.hide();
  }
}
